import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决路由重复跳转报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: (resolve) =>
        require(["../components/page/eswinHome/eswinHome.vue"], resolve),
      children: [
        {
          path: "index",
          component: (resolve) =>
            require(["../components/page/eswinHome/eswinMain"], resolve),
          meta: {
            title: "首页",
            nav: "index",
          },
        },
        {
          path: "en/",
          component: (resolve) =>
            require(["../components/page/eswinHome/eswinMain"], resolve),
          meta: {
            title: "英文",
            nav: "en",
          },
        },
        {
          path: "company",
          component: (resolve) =>
            require(["../components/page/eswinHome/company/index"], resolve),
          meta: {
            title: "公司简介",
            nav: "company",
          },
        },
        {
          path: "qualityAssurance",
          component: (resolve) =>
            require(["../components/page/eswinHome/qualityAssurance/index"], resolve),
          meta: {
            title: "质量保障",
            nav: "qualityAssurance",
          },
        },
        {
          path: "compliance",
          component: (resolve) =>
            require(["../components/page/eswinHome/compliance/index"], resolve),
          meta: {
            title: "合规管理",
            nav: "compliance",
          },
        },
        {
          path: "news",
          component: (resolve) =>
            require(["../components/page/eswinHome/news/index"], resolve),
          meta: {
            title: "新闻中心",
            nav: "news",
          }
        },
        {
          path: "contact",
          component: (resolve) =>
            require(["../components/page/eswinHome/contact/index"], resolve),
          meta: {
            title: "联系我们",
            nav: "contact",
          },
        },
        {
          path: "product",
          component: (resolve) =>
            require(["../components/page/eswinHome/product/index"], resolve),
          meta: {
            title: "产品与技术",
            nav: "product",
          },
        },
        {
          path: "laboratory",
          component: (resolve) =>
            require(["../components/page/eswinHome/service/laboratory"], resolve),
          meta: {
            title: "实验室服务",
            nav: "laboratory",
          },
        },
        {
          path: "service",
          component: (resolve) =>
            require(["../components/page/eswinHome/service/index"], resolve),
          meta: {
            title: "封测服务",
            nav: "service",
          },
        },
        {
          path: "guarantee",
          component: (resolve) =>
            require(["../components/page/eswinHome/service/guarantee"], resolve),
          meta: {
            title: "服务保障",
            nav: "guarantee",
          },
        },
        {
          path: "simulation",
          component: (resolve) =>
            require(["../components/page/eswinHome/service/simulation"], resolve),
          meta: {
            title: "设计仿真服务",
            nav: "simulation",
          },
        },
        {
          path: "new",
          component: (resolve) =>
            require(["../components/page/eswinHome/news/news_details/news"], resolve),
        },
        {
          path: "techPlat",
          component: (resolve) =>
            require(["../components/page/eswinHome/product/techPlat"], resolve),
          meta: {
            title: "技术平台",
            nav: "techPlat",
          },
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js